import { addressFromPublicKey, bytesToHex } from './wallet';
import { solanaAddress } from './ed25519';
import { bitcoinAddress } from './bitcoin';
import { tronAddress, cosmosAddress, aptosAddress, stellarAddress } from './addresses';

export type Curve = 'secp256k1' | 'ed25519';

export type NetworkDef = {
  id: string;
  curve: Curve;
  deriveAddress: (publicKey: Uint8Array) => string;
};

const registry: Record<string, NetworkDef> = {
  ethereum: { id: 'ethereum', curve: 'secp256k1', deriveAddress: addressFromPublicKey },
  bitcoin:  { id: 'bitcoin',  curve: 'secp256k1', deriveAddress: bitcoinAddress },
  tron:     { id: 'tron',     curve: 'secp256k1', deriveAddress: tronAddress },
  cosmos:   { id: 'cosmos',   curve: 'secp256k1', deriveAddress: cosmosAddress },
  solana:   { id: 'solana',   curve: 'ed25519',   deriveAddress: solanaAddress },
  near:     { id: 'near',     curve: 'ed25519',   deriveAddress: (pub) => bytesToHex(pub) },
  aptos:    { id: 'aptos',    curve: 'ed25519',   deriveAddress: aptosAddress },
  stellar:  { id: 'stellar',  curve: 'ed25519',   deriveAddress: stellarAddress },
};

export function curvesForNetworks(networks: string[]): Curve[] {
  const seen = new Set<Curve>();
  for (const n of networks) {
    const def = registry[n];
    if (def) seen.add(def.curve);
  }
  return [...seen].sort();
}

export function deriveAddress(network: string, publicKey: Uint8Array): string {
  const def = registry[network];
  if (!def) throw new Error(`unknown network: ${network}`);
  return def.deriveAddress(publicKey);
}

export function getNetwork(id: string): NetworkDef | undefined {
  return registry[id];
}

export function networkIds(): string[] {
  return Object.keys(registry).sort();
}
